/**
 * Roles allowed to view financial management dashboards and billing surfaces.
 */
export const FINANCIAL_DASHBOARD_ALLOWED_ROLES = [
    'admin',
    'director',
    'manager',
    'finance',
    'accountant',
    'cfo',
];

/**
 * @param {{ role?: string, is_superuser?: boolean } | null | undefined} user
 * @returns {boolean}
 */
export const canAccessFinancialDashboard = (user) => {
    if (!user) {
        return false;
    }
    if (user.is_superuser) {
        return true;
    }
    return FINANCIAL_DASHBOARD_ALLOWED_ROLES.includes(user.role);
};
